import React from 'react';
import { StaticImage } from 'gatsby-plugin-image';

const StaticPicture = ({ imgFile, altText, size }) => {
  const renderImg = (imageSize) => {
    let image;
    switch (imageSize) {
      case 'xlg':
        image = (
          <StaticImage
            src='../../images/1366x768.jpg'
            alt='Placeholder logo - pandamic action network'
            placeholder='blurred'
          />
        );
        break;
      case 'lg':
        image = (
          <StaticImage
            src='../../images/600x388.jpg'
            alt='Placeholder logo - pandamic action network'
            placeholder='blurred'
          />
        );
        break;
      case 'l':
        image = (
          <StaticImage
            src='../../images/323x215.jpg'
            alt='Placeholder logo - pandamic action network'
            placeholder='blurred'
          />
        );
        break;
      case 'm':
        image = (
          <StaticImage
            src='../../images/310x176.jpg'
            alt='Placeholder logo - pandamic action network'
            placeholder='blurred'
          />
        );
        break;
      case 's':
        image = (
          <StaticImage
            src='../../images/100x57.jpg'
            alt='Placeholder logo - pandamic action network'
            placeholder='blurred'
          />
        );
        break;
      default:
        image = (
          <StaticImage
            src='../../images/310x176.jpg'
            alt='Placeholder logo - pandamic action network'
            placeholder='blurred'
          />
        );
        break;
    }
    return image;
  };
  return imgFile ? <img src={imgFile} alt={altText} /> : renderImg(size);
};

export default StaticPicture;
